export default "__VITE_ASSET__Dsu6NqCH__";